import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AlertContext from "../../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../../Files/BaseURL";

const CompanyProfile = () => {
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertContext);

  // State variables for form fields
  const [companyName, setCompanyName] = useState("");
  const [crnNumber, setCrnNumber] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [CountryList, setCountryList] = useState([])

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic client-side validation
    if (
      !companyName ||
      !crnNumber ||
      !address ||
      !city ||
      !country ||
      !state ||
      !zip
    ) {
      showAlert("Please fill in all required fields.", "danger");
      return;
    }

    setIsSubmitting(true);

    try {
      const authToken = localStorage.getItem("p@token");
      const response = await fetch(`${BaseURL}/api/business/companysetup/companysetup`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "auth-token": authToken,
        },
        body: JSON.stringify({
          Name: companyName,
          Registeration_num: crnNumber,
          Address:address,
          City: city,
          State: state,
          Zip: zip,
          Country: country,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        showAlert(data.message, "success");
        navigate("/profileCreation/company/shareholder");
      } else {
        const errorData = await response.json();
        showAlert(errorData.message || "Failed to create company setup.", "danger");
      }
    } catch (error) {
      showAlert(error.message || "An error occurred.", "danger");
    } finally {
      setIsSubmitting(false);
    }
  };

  const fetchCountry = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/auth/getcountry`);
      const data = await response.json();
      setCountryList(data.Country);
    } catch (error) {
      showAlert(error.message, 'danger');
    }
  };

  useEffect(() => {
    fetchCountry()
  }, [])

  return (
    <>
      {/* Progress Bar */}
      <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600">
        <div className="h-2 bg-green-500" style={{ width: "45%" }}></div>
      </div>

      {/* Form Container */}
      <div className="py-2 flex justify-center font-pop items-center w-[90%] md:w-[60%] xl:w-[30%] m-auto">
        <div className="card bg-white p-8 rounded-lg shadow-md w-full">
          <h2 className="text-2xl font-bold mb-4 text-center">Company Profile</h2>
          <p className="text-gray-600 mb-6">Company Information</p>

          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            {/* Company Name */}
            <input
              type="text"
              id="cname"
              placeholder="Company Name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              required
            />

            {/* CRN Registration Number */}
            <input
              type="text"
              id="crn"
              placeholder="CRN Registration Number"
              value={crnNumber}
              onChange={(e) => setCrnNumber(e.target.value)}
              className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              required
            />

            <hr className="mb-3" />
            <p className="text-gray-600 mb-6">Address</p>

            {/* Street Address */}
            <input
              type="text"
              id="streetA"
              placeholder="Street Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              required
            />

            {/* City */}
            <input
              type="text"
              id="city"
              placeholder="City"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              required
            />

            {/* Country */}
            <div className="mb-4">
              <select
                name="country"
                id="country"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              >
                <option value="">Select Country</option>
                {CountryList.map((item, index) => (
                  <option value={item}>{item}</option>
                ))}
              </select>
            </div>

            {/* State and Zip Code */}
            <div className="mb-4 flex justify-between gap-2">
              {/* State */}
              <input
                name="state"
                id="state"
                placeholder="State"
                value={state}
                onChange={(e) => setState(e.target.value)}
                className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
                required
              />

              {/* Zip Code */}
              <input
                type="number"
                id="zip-code"
                name="zip-code"
                placeholder="Zip Code"
                value={zip}
                onChange={(e) => setZip(e.target.value)}
                className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
                required
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className={`my-4 bg-green-500 ${
                isSubmitting ? "opacity-50 cursor-not-allowed" : "hover:bg-transparent hover:bg-white-500"
              } font-semibold hover:text-black py-2 px-4 border border-black-500 hover:border-green-500 rounded-full w-full text-white animate__animated animate__backInUp transition duration-300`}
            >
              {isSubmitting ? "Submitting..." : "Next"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default CompanyProfile;
